<template>
  <div class="sourceMaterial">
    <h3 class="sourceMaterial_title">素材库</h3>
    <el-tabs v-model="activeName">
      <el-tab-pane label="图片\视频\音频" name="first"><ImgComp v-if="activeName === 'first'" /> <div v-else /></el-tab-pane>
      <!-- <el-tab-pane label="音频" name="second"><AudioComp v-if="activeName === 'second'" /><div v-else /></el-tab-pane> -->
      <!-- <el-tab-pane label="视频" name="third">视频</el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import ImgComp from './components/imgComp.vue'
// import AudioComp from './components/audioComp.vue'
export default {
  components: {
    ImgComp
    // AudioComp
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="less" scoped>
.sourceMaterial{
  margin: 0 auto;
  margin-top: 30px;
  width: 90%;
  .sourceMaterial_title{

  }
}
</style>
